import { render, staticRenderFns } from "./RefundReason.vue?vue&type=template&id=bc490d28&scoped=true&"
import script from "./RefundReason.vue?vue&type=script&lang=js&"
export * from "./RefundReason.vue?vue&type=script&lang=js&"
import style0 from "./RefundReason.vue?vue&type=style&index=0&id=bc490d28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc490d28",
  null
  
)

export default component.exports